import React, {Component} from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Navbar,
  NavbarToggler,
  NavbarBrand
} from 'reactstrap';

import firebase from 'firebase/app';
import 'firebase/auth';

import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /addSocials after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: '/_addSocials',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  ]
};
 
class Register extends Component {
    constructor(props) {
      super(props);

      this.toggle = this.toggle.bind(this);
      this.state = {
        isOpen: false
      };
    }
    toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }

  render() {
    return (
      <div>
		<Navbar color="dark" dark expand="md">
          <NavbarBrand href="/">D16175</NavbarBrand>
		  <NavbarToggler onClick={this.toggle} />
		</Navbar>
		<br/>
		<Row className="justify-content-center">
			<Col xs="12" sm="6" md="4">
				<Card>
					<CardHeader>
						<strong>Create SenseEV account</strong>
					</CardHeader>
					<CardBody>
						<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
					</CardBody>
				</Card>
			</Col>
		</Row>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js